import classNames from 'classnames';
import { createElement, ReactNode } from 'react';
import styles from './Heading.module.scss';

type Props = {
  as: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  children: ReactNode;
  className?: string;
  id?: string;
  size: '100' | '200' | '300' | '400' | '500' | '600' | '700';
};

// https://www.figma.com/design/9Y1n3VoMJAcTGPe82bvySj/Denali-Components?node-id=18338-83084&m=dev
// Similar components
// https://www.radix-ui.com/themes/docs/components/heading
// https://primer.style/product/components/heading/
export default function Heading({ as, children, className, id, size }: Props) {
  return createElement(as, { className: classNames(styles.heading, styles[`heading${size}`], className), id }, children);
}
